import React from 'react'
import { Trans } from '@lingui/react'
import { TOPBAR_HEIGHT } from './TopBar'
import MainSideBar from './MainSideBar'
import AppContainer from './AppContainer'
import Icon from '../util/Icon'
import Title from '../util/Title'


const PageError = ({ error, ...props }) => (
    <AppContainer {...props}>
        <MainSideBar />
        <div className="w-full flex-1">
            <main
                className="flex items-center justify-center flex-col overflow-auto p-10 bg-gray-50"
                style={{ height: `calc(100% - ${TOPBAR_HEIGHT}rem)` }}
            >
                <Icon
                    isLarge
                    name="alarm"
                    accentColor="primary"
                    className="mb-2"
                />
                <Title>
                    <Trans id="Something went wrong!" />
                </Title>
                {error ? <p className="text-center">{error}</p> : null}
            </main>
        </div>
    </AppContainer>
)

export default PageError
